import OverviewExportMenu from "./OverviewExportMenu";
import {
  buildRpeOverviewFileBase,
  buildRpeOverviewSheets,
  buildRpeOverviewSingleCsvRows,
} from "./rpeOverviewExportUtils";

export default function RpeOverviewExportMenu({ data, isDarkMode = false, disabled = false }) {
  return (
    <OverviewExportMenu
      data={data}
      isDarkMode={isDarkMode}
      disabled={disabled}
      buildSheets={buildRpeOverviewSheets}
      buildSingleCsvRows={buildRpeOverviewSingleCsvRows}
      buildFileBase={buildRpeOverviewFileBase}
      i18nPrefix="export_rpe_overview"
      theme="amber"
    />
  );
}
